import { Button, Form, Select } from 'antd';
import { getSelectList, SelectList, SelectPayload } from 'api/dashboard';
import { LoanTypePayload } from 'api/master';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LoanTypeList from '../LoanTypeList';

type Props = {
  isLoading: boolean;
  onSubmit: (values: LoanTypePayload) => Promise<void>;
};

const filterPayload: LoanTypePayload = {};
const initPartners: SelectList[] = [];

const LoanType = ({ onSubmit }: Props) => {
  const [filter, setFilter] = useState(filterPayload);
  const { Option } = Select;
  const [form] = Form.useForm<LoanTypePayload>();
  const navigate = useNavigate();
  const [statusList, setStatus] = useState(initPartners);
  const [statusId, setStatusId] = useState(0);
  const [isReset, setReset] = useState(false);

  useEffect(() => {
    const statusPayload: SelectPayload = {
      SKey: 'LoanType',
    };

    // setIsLoading(false);
    getSelectList(statusPayload).then((res) => {
      // setPagedList(res);
      //   setIsLoading(true);
      setStatus(res.data);
    });
  }, []);

  const handleLoanId = (e: any) => {
    form.setFieldValue('statusId', e);
    form.validateFields(['statusId']);
    setStatusId(Number(e));
  };

  const handleSubmit = useCallback(
    async (values: LoanTypePayload) => {
      let updatedValues = { ...values };
      updatedValues.Username = sessionStorage.getItem('user')?.toString();
      updatedValues.SourceApplicationName = sessionStorage.getItem('source')?.toString();
      setFilter(updatedValues);
      // form.resetFields();
    },
    [onSubmit, form]
  );

  const handleLoanType = () => {
    navigate('/master/loan-type/add');
  };

  const handleReset = async (_e: any) => {
    form.resetFields();
    let updatedFilter = { ...filter };
    updatedFilter = filterPayload;
    setFilter(updatedFilter);
    setReset(true);
  };

  return (
    <div className="container">
      <div className="row">
        <div className="col-xs-12 col-sm-12 col-md-12">
          <div className="mid-container">
            <div className="submission-box">
              <h2>Loan Type</h2>
              <div className="submission-htmlForm">
                {/* <form action="/AvanseApp/Home/Filter" classNameName="standard-htmlForms" id="frmDashboard" method="post" /> */}
                <Form<LoanTypePayload>
                  form={form}
                  onFinish={handleSubmit}
                  layout="vertical"
                  scrollToFirstError
                  className="standard-forms"
                  initialValues={{
                    ['Username']: sessionStorage.getItem('user')?.toString(),
                    //['SourceApplicationName']: sessionStorage.getItem('source')?.toString(),
                  }}
                >
                  <div className="row">
                    <div className="col-xs-12 col-sm-6 col-md-6">
                      <div className="input-box">
                        <Form.Item label={'LoanType :'} name="LoanType" className="fieldTitle">
                          <Select
                            defaultValue={'Select'}
                            size="large"
                            value={statusId.toString()}
                            onSelect={handleLoanId}
                          >
                            {statusList.map((status) => (
                              <>
                                <Option value={status.SValue}>{status.SText}</Option>
                              </>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                    {/* <div className="col-xs-12 col-sm-6 col-md-6">
                                            <div className="input-box">
                                                <Form.Item
                                                    label={'Payment Purpose :'}
                                                    name="PaymentPurpose"
                                                    className="fieldTitle"
                                                > */}
                    {/* <InputNumber placeholder={'Payment Purpose'} /> */}
                    {/* <Select defaultValue="0" size="large">
                                                        <Option value="0">Select</Option>
                                                        <Option value="Fees">Fees</Option>
                                                        <Option value="Foreclosure">Foreclosure</Option>
                                                        <Option value="Overdue">Overdue</Option>
                                                        <Option value="OverdueWithoutCharges">Overdue Without Charges</Option>
                                                        <Option value="PartPayment">PartPayment</Option>
                                                        <Option value="ADVANCEEMI">Advance EMI</Option>
                                                    </Select> */}
                    {/* </Form.Item>
                                            </div>
                                        </div> */}
                  </div>
                  <div style={{ marginBottom: '20px' }}>
                    <Button
                      type="primary"
                      onClick={handleLoanType}
                      style={{ float: 'right', marginRight: '5px' }}
                    >
                      {'CREATE LOAN TYPE'}
                    </Button>
                    &nbsp; &nbsp;
                    <Button
                      type="primary"
                      onClick={handleReset}
                      style={{ float: 'right', marginRight: '10px' }}
                    >
                      {'CLEAR'}
                    </Button>
                    &nbsp; &nbsp;
                    <Button
                      type="primary"
                      htmlType="submit"
                      onClick={() => {
                        setReset(false);
                      }}
                      style={{ float: 'right', marginRight: '10px' }}
                    >
                      {'SEARCH'}
                    </Button>
                    &nbsp; &nbsp;
                  </div>
                </Form>
              </div>
              {!isReset ? <LoanTypeList filter={{ ...filter }} onSubmit={handleSubmit} /> : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoanType;
